import {defineMessages} from "react-intl";

export default defineMessages({
    notificationSettings: {id: "accessListFilters.notificationSettings", defaultMessage: "Notification settings", description: 'accessListFilters: Notification settings'},
    originPrefixDestination: {id: "accessListFilters.originPrefixDestination", defaultMessage: "Origin/origin prefix/destination", description: 'accessListFilters: Origin/origin prefix/destination'},
    deleteAccessListFilter: {id: "common.deleteAccessListFilter", defaultMessage: "Delete access list filter", description: 'accessListFilters: Delete access list filter'},
})